<div id="tvd-program-details-page" class="flex flex-col gap-4 bg-light-blue">
  <section
    id="tvd-program-details-summary"
    class="px-8 py-4 ml-neptune-sidebar"
  >
    <ng-container *ngIf="!isLoading; else loadingTemplate">
      <div class="grid grid-cols-2 lg:grid-cols-3 gap-4 auto-rows-fr">
        <div
          class="program-name bg-white rounded-xl p-6 flex flex-col justify-between border border-solid border-sky-blue gap-6"
        >
          <span
            class="value text-3xl sm:text-xl lg:text-3xl font-semibold text-neptune-default"
            >{{ programName }}</span
          ><span class="label text-lg">Program</span>
        </div>

        <div
          class="total-value-delivered bg-white rounded-xl p-6 flex flex-col justify-between border border-solid border-sky-blue gap-6"
        >
          <span
            class="value text-3xl sm:text-xl lg:text-3xl font-semibold text-neptune-default"
          >
            <span class="currency-symbol">{{
              currencyCode | currencySymbol
            }}</span>
            <span class="delivered-value"
              ><ng-container
                *ngIf="
                  totalValueDelivered > 0 && totalValueDelivered < 1;
                  else actualTvdValue
                "
              >
                &lt;1
              </ng-container>
              <ng-template #actualTvdValue>
                {{
                  displayInRoundedNumber
                    ? (getDisplayValue(totalValueDelivered) | abbreviateNumber)
                    : (getDisplayValue(totalValueDelivered) | number: "1.0-0")
                }}
              </ng-template></span
            > </span
          ><span class="label text-lg">Total Value Delivered</span>
        </div>

        <div
          class="impact-categories bg-white rounded-xl p-6 flex flex-col justify-between border border-solid border-sky-blue gap-6"
        >
          <span
            class="value text-3xl sm:text-xl lg:text-3xl font-semibold text-neptune-default"
          >
            <span class="block truncate" [title]="impactCategories.join(', ')">
              {{ impactCategories.join(", ") }}
            </span> </span
          ><span class="label text-lg">Contributing Impact Categories</span>
        </div>

        <div
          class="total-products bg-white rounded-xl p-6 flex flex-col justify-between border border-solid border-sky-blue gap-6"
        >
          <span
            class="value text-3xl sm:text-xl lg:text-3xl font-semibold text-neptune-default"
            >{{ totalProducts }}</span
          ><span class="label text-lg">Contributing Products</span>
        </div>

        <div
          class="average-tvd-per-product bg-white rounded-xl p-6 flex flex-col justify-between border border-solid border-sky-blue gap-6"
        >
          <span
            class="value text-3xl sm:text-xl lg:text-3xl font-semibold text-neptune-default"
          >
            <span class="currency-symbol">{{
              currencyCode | currencySymbol
            }}</span>
            <span class="average-value">
              <ng-container
                *ngIf="
                  averageTvdPerProduct > 0 && averageTvdPerProduct < 1;
                  else actualAvgValue
                "
              >
                &lt;1
              </ng-container>
              <ng-template #actualAvgValue>
                {{
                  displayInRoundedNumber
                    ? (getDisplayValue(averageTvdPerProduct) | abbreviateNumber)
                    : (getDisplayValue(averageTvdPerProduct) | number: "1.0-0")
                }}
              </ng-template>
            </span> </span
          ><span class="label text-lg">Average TVD per Product</span>
        </div>

        <div
          class="total-locations bg-white rounded-xl p-6 flex flex-col justify-between border border-solid border-sky-blue gap-6"
        >
          <span
            class="value text-3xl sm:text-xl lg:text-3xl font-bold text-neptune-default"
            >{{ totalLocations }}</span
          ><span class="label text-lg">Contributing Locations</span>
        </div>
      </div>
    </ng-container>

    <ng-template #loadingTemplate>
      <div class="details-loader flex justify-center py-8">
        <loader [size]="'medium'"></loader>
      </div>
    </ng-template>
  </section>

  <tvd-program-details-table [selectedProgramName]="programName" />
</div>
